module.exports = __webpack_public_path__ + "assets/icons/ic_cancel_24px.svg";